import {Alert, Snackbar} from "@mui/material";
import React from "react";


const success = ({successMessage,children,setSuccessMessage, severity}) => {

const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }

    setSuccessMessage(false);
};


return (

<Snackbar open={successMessage} autoHideDuration={6000} onClose={handleClose}>
    <Alert onClose={handleClose} severity={successMessage?.success == true ? "success":"error"} sx={{width: '100%'}}>
        {children}
    </Alert>
</Snackbar>
)
}

export default success;